import React, { FC } from 'react';
import RSuiteDatePicker from 'rsuite/DatePicker';
import 'rsuite/dist/rsuite.min.css';

interface IWFDatePicker {
  label: string;
  date: Date | null;
  onDateChange: (date: Date | null) => void;
  onDateClear: () => void;
  className?: string;
}

const WFDatePicker: FC<React.PropsWithChildren<IWFDatePicker>> = ({
  label,
  date,
  onDateChange,
  onDateClear,
  className,
}) => {
  return (
    <div
      className={`bg-white font-montserrat flex items-center shadow-[2px_4px_4px_rgba(0,0,0,0.07)] rounded-[5px] max-[1279px]:basis-full max-[1279px]:min-w-[px] max-[1279px]:mb-1.5 ${className ||
        ''}`}
    >
      <RSuiteDatePicker
        size="lg"
        placeholder={label}
        value={date}
        onChange={onDateChange}
        onClean={onDateClear}
        cleanable
        className="flex-grow"
      />
    </div>
  );
};

export default WFDatePicker;
